import { Link } from "@inertiajs/react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { privacyPath } from "@/routes";

const COOKIE_BANNER_COOKIE_NAME = "cookie_banner_acknowledged_v1";
const COOKIE_BANNER_MAX_AGE = 60 * 60 * 24 * 180;

function readBannerAcknowledged() {
  if (typeof document === "undefined") return false;

  return document.cookie
    .split(";")
    .map((part) => part.trim())
    .some((part) => part === `${COOKIE_BANNER_COOKIE_NAME}=true`);
}

function writeBannerAcknowledged() {
  if (typeof document === "undefined") return;

  const secure = window.location.protocol === "https:" ? "; secure" : "";

  document.cookie =
    `${COOKIE_BANNER_COOKIE_NAME}=true; ` +
    `path=/; max-age=${COOKIE_BANNER_MAX_AGE}; samesite=lax${secure}`;
}

export function CookieConsentBanner() {
  const [acknowledged, setAcknowledged] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setAcknowledged(readBannerAcknowledged());
    setReady(true);
  }, []);

  const acceptCookies = () => {
    writeBannerAcknowledged();
    setAcknowledged(true);
  };

  const bannerVisible = ready && !acknowledged;

  if (!bannerVisible) return null;

  return (
    <section className="border-border bg-background/95 fixed right-4 bottom-4 left-4 z-50 rounded-3xl border shadow-lg backdrop-blur md:left-auto md:max-w-md">
      <div className="space-y-4 p-5">
        <div className="space-y-2">
          <p className="text-sm font-semibold">Cookies</p>
          <p className="text-muted-foreground text-sm leading-6">
            We use cookies to help this site work properly and improve your experience.
          </p>
          <p className="text-muted-foreground text-sm leading-6">
            See our{" "}
            <Link href={privacyPath()} className="underline underline-offset-4">
              Privacy Policy
            </Link>
            .
          </p>
        </div>

        <div className="flex justify-end">
          <Button onClick={acceptCookies}>Accept cookies</Button>
        </div>
      </div>
    </section>
  );
}
